"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Email = void 0;
/**
 * Email
 * @public
 */
var Email;
(function (Email) {
    Email.schema = {
        type: 'string',
        pattern: '^[\\w\\-\\.]+@([\\w-]+\\.)+[\\w-]{2,}$'
    };
    const regexp = new RegExp(Email.schema.pattern);
    Email.validate = (email) => regexp.test(email);
})(Email = exports.Email || (exports.Email = {}));
//# sourceMappingURL=email.js.map